/* eslint-disable no-param-reassign */
export default function createPredict(history = []) {
	const map = history.reduce((obj, options) => (
		(obj[options[0].toLowerCase()] = options.slice(1)) && obj
	), {})

	return (string) => map[string.toLowerCase()] || []
}



// WEBPACK FOOTER //
// ./src/services/prediction/optionsHistory.js